import _extends from "@babel/runtime/helpers/esm/extends";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { createCrud, useAxiosClient, useMutation } from '@lumahealthhq/ui-model';
var BASE_URL = 'insurancepayors';
var crud = createCrud(BASE_URL);
export var useInsurancePayorUpdateOne = crud.makeUpdateOne();
export function useInsurancePayorUpdateMany() {
  var axiosClient = useAxiosClient();
  var fetchFn = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
      var ids, values, _yield$axiosClient$pu, data;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            ids = _ref.ids, values = _ref.values;
            _context.next = 3;
            return axiosClient.put("v2/".concat(BASE_URL, "/bulk"), _extends({
              ids: ids
            }, values));
          case 3:
            _yield$axiosClient$pu = _context.sent;
            data = _yield$axiosClient$pu.data;
            return _context.abrupt("return", data);
          case 6:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function fetchFn(_x) {
      return _ref2.apply(this, arguments);
    };
  }();
  var mutationResult = useMutation(['insurancepayors'], function (data) {
    return fetchFn(data);
  });
  return mutationResult;
}

// TODO: roger-rigoni - dont use yet.
export function useInsurancePayorSyncMany() {
  var axiosClient = useAxiosClient();
  var fetchFn = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(insurancePayorsIds) {
      var _yield$axiosClient$po, data;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return axiosClient.post("v2/".concat(BASE_URL, "/sync-many"), {
              insurancePayorsIds: insurancePayorsIds
            });
          case 2:
            _yield$axiosClient$po = _context2.sent;
            data = _yield$axiosClient$po.data;
            return _context2.abrupt("return", data);
          case 5:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function fetchFn(_x2) {
      return _ref3.apply(this, arguments);
    };
  }();
  var mutationResult = useMutation(['insurancepayors'], fetchFn);
  return mutationResult;
}